module.exports = "<label class=\"{{this.className}}\">\n    <i class=\"fa fa-barcode\"></i>&nbsp;&nbsp;{{this.text}}\n</label>\n"